module.exports = __webpack_public_path__ + "img/rg.67ac40d3.jpg";